<template>
    <router-link :to="detailRoute"
        class="block no-underline text-inherit p-3 my-2 rounded-lg border-1 transition-all hover:shadow-md border-gray-300 hover:border-customBlue-100 bg-white cursor-pointer">
        <div class="flex flex-col gap-1">
            <div class="flex items-center justify-between gap-2 mb-1">
                <div>
                    <p class="m-0 font-roboto text-[14px] leading-[20px] font-normal text-[#EA8A8A]">
                        {{ !item.created_at ? '-' : $helper.formatDateTime(item.created_at) }}
                    </p>
                </div>
                <span v-if="!isBlank(item.status_text)" :style="{ backgroundColor: getStatusClass(item.status_text) }"
                    class="text-white rounded-md px-2 py-[2px] capitalize block w-fit flex-shrink-0 whitespace-nowrap font-roboto text-[12px] leading-[16px] font-normal"
>
                    {{ formatStatus(item.status_text) }}
                </span>
            </div>

            <div class="flex items-center justify-between gap-2">
                <div>
                    <span class="text-[#BA90C6] font-roboto text-[13px] leading-[18px] block">Order ID:</span>
                    <p class="text-[#333333] m-0 font-roboto text-[14px] leading-[20px] font-normal">
                        {{ show(item.id) }}
                    </p>
                </div>
                <img v-if="partnerLogo(item)" :src="partnerLogo(item)" :alt="item.depp_schedule.company_name || 'Partner'"
                    class="w-12 h-10 object-contain flex-shrink-0" @error="$event.target.style.display = 'none'">
            </div>
            <div>
                <span class="text-[#BA90C6] font-roboto text-[13px] leading-[18px] block">System Type:</span>
                <p class="text-[#333333] m-0 font-roboto text-[14px] leading-[20px] font-normal">
                    {{ show(item.type) }}
                </p>
            </div>
            <div>
                <span class="text-[#BA90C6] font-roboto text-[13px] leading-[18px] block">Consumer Name:</span>
                <p class="text-[#333333] m-0 font-roboto text-[14px] leading-[20px] font-normal">
                    {{ show(item.consumer?.full_name) }}
                </p>
            </div>
            <div class="grid grid-cols-5">
                <div class="col-span-3">
                    <span class="text-[#BA90C6] font-roboto text-[13px] leading-[18px] block">Installation Date:</span>
                    <p class="text-[#333333] m-0 font-roboto text-[14px] leading-[20px] font-normal">
                        {{ !item.installation_datetime ? '-' : $helper.formatDateTime(item.installation_datetime) }}
                    </p>
                </div>
                <div class="col-span-2">
                    <span class="text-[#BA90C6] font-roboto text-[13px] leading-[18px] block">Order Amount:</span>
                    <p class="text-[#333333] m-0 font-roboto text-[14px] leading-[20px] font-normal">
                        {{ $helper.isEmpty(item.total) ? '-' : '$' + $helper.formatAmount(item.total) }}
                    </p>
                </div>
            </div>
</div>
    </router-link>
</template>
<script>
import { rqStatusColor } from "../../services/rqApi";

export default {
    components: {
    },
    props: ["item"],
    data() {
        return {
            isOpen: false,
            user: JSON.parse(localStorage.getItem("user")) ?? null
        };
    },
    computed: {
        detailRoute() {
            return `/replacement-quote/detail/${this.item.id}`;
        },
    },
    mounted() {
    },
    unmounted() {
    },
    methods: {
        // partner (NRG / DEPP) job: depp_schedule.status with the company logo (Android CompletedJobsAdapter / OrderAdapter)
        partnerLogo(item) {
            const p = item.depp_schedule;
            return p && [1, "1", true].includes(p.status) && p.company_logo ? p.company_logo : null;
        },
        isBlank(value) {
            return value === null || value === undefined || String(value).trim() === '';
        },
        // Empty cells show "-"
        show(value) {
            return this.isBlank(value) ? '-' : value;
        },
        getStatusClass(status) {
            return rqStatusColor(status);
        },
        formatStatus(status) {
            return status
                ?.toLowerCase()
                .replace(/\b\w/g, char => char.toUpperCase());
        }
    }
};
</script>